import api from '@/apis'
import Vuetify from '@/plugins/vuetify'

export default {
  state: {
    table: {
      keyword: null,
      loading: false,
      loading_index: null,
      items_per_page: 10,
      total_items: null,
      headers: [
        { title: '', key: 'is_activated', sortable: false, width: 80 },
        { title: Vuetify.locale.t('$vuetify.__General.question_topic'), key: 'intent_name' },
        { title: Vuetify.locale.t('$vuetify.__General.category'), key: 'category_name' },
        { title: Vuetify.locale.t('$vuetify.__General.remarks'), key: 'remarks' },
        { title: '', key: 'action', sortable: false, width: 200 }
      ],
      items: []
    },
    selected_category: null
  },
  mutations: {
    SET_KEYWORD_DATA_TABLE_KEYWORD(state, payload) {
      state.table.keyword = payload
    },
    SET_KEYWORD_DATA_TABLE_LOADING(state, payload) {
      state.table.loading = payload
    },
    SET_KEYWORD_DATA_TABLE_LOADING_INDEX(state, payload) {
      state.table.loading_index = payload
    },
    SET_KEYWORD_DATA_TABLE_TOTAL_ITEMS(state, payload) {
      state.table.total_items = payload
    },
    SET_KEYWORD_DATA_TABLE_ITEMS(state, payload) {
      state.table.items = payload
    },
    SET_KEYWORD_DATA_SELECTED_CATEGORY(state, payload) {
      state.selected_category = payload
    }
  },
  actions: {
    async fetchQuestionTopicList({ state, commit }, payload) {
      try {
        commit('SET_KEYWORD_DATA_TABLE_LOADING', true)
        commit('SET_KEYWORD_DATA_TABLE_ITEMS', [])
        commit('SET_KEYWORD_DATA_TABLE_TOTAL_ITEMS', null)

        const selected_category = state.selected_category
        const keyword = state.table.keyword
        const page = payload?.options?.page ? payload.options.page : 1
        const itemsPerPage = payload?.options?.itemsPerPage ? payload.options.itemsPerPage : 10
        const sortBy = payload?.options?.sortBy[0] ? payload.options.sortBy[0] : null
        let sort_by = null
        if (sortBy) {
          if (sortBy.key === 'remarks') sort_by = 'remarks'
          else sort_by = sortBy.key.slice(0, -5)
        }
        const order = sortBy ? sortBy.order : null

        const response = await api.getQuestionTopicList({
          category_id: selected_category,
          search: keyword,
          limit: itemsPerPage,
          offset: page * itemsPerPage - itemsPerPage,
          sort_by: sort_by,
          order: order
        })
        if (response.data.success) {
          commit('SET_KEYWORD_DATA_TABLE_ITEMS', response.data.data)
          commit('SET_KEYWORD_DATA_TABLE_TOTAL_ITEMS', response.data.total)
        } else throw Error(response.data.message)
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_KEYWORD_DATA_TABLE_LOADING', false)
      }
    },
    async updateQuestionTopicStatusInKeywordData({ commit, state }, payload) {
      try {
        commit('SET_SNACKBAR', { status: true, color: 'loading', text: Vuetify.locale.t('$vuetify.__SnackBar.update_question_topic_status'), loading: true })
        commit('SET_KEYWORD_DATA_TABLE_LOADING_INDEX', payload.id)
        const response = await api.updateQuestionTopic({ params: { id: payload.id, is_activated: payload.is_activated } })
        if (response.data.success) {
          commit('SET_SNACKBAR', { status: true, color: 'success', text: Vuetify.locale.t('$vuetify.__SnackBar.update', ''), icon: 'check', timeout: '2000' })
        } else {
          let index = state.table.items.findIndex((obj) => obj.id === payload.id)
          const new_val = !state.table.items[index].is_activated
          state.table.items[index].is_activated = new_val
          throw Error(response.data.message)
        }
      } catch (error) {
        commit('SET_SNACKBAR', { status: true, color: 'error', text: error.message, icon: 'close', timeout: '2000' })
      } finally {
        commit('SET_KEYWORD_DATA_TABLE_LOADING_INDEX', null)
      }
    }
  }
}
